var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isObjective || _vm.isKeyResult)?_c('div',{staticClass:"comment",domProps:{"innerHTML":_vm._s(_vm.post.comment.content)}}):_c('span',[_vm._v("\n        "+_vm._s(_vm.post.comment.content)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }